export async function apiGet(url: string, init?: RequestInit): Promise<Response> {
  const opts: RequestInit = { ...(init || {}) };
  if (process.env.REACT_APP_STAGING === 'true') {
    opts.cache = 'no-store';
  }
  return fetch(url, opts);
}

/**
 * For polling hooks: freshness is governed entirely by the poll interval, so the
 * request must always bypass the browser HTTP cache, not just when REACT_APP_STAGING
 * is set. Centralizing this here (rather than each poller passing its own
 * `{cache:'no-store'}` override) means a new poller can't forget the override and
 * silently reintroduce a stale-poll bug.
 */
export async function apiGetFresh(url: string, init?: RequestInit): Promise<Response> {
  return apiGet(url, { ...(init || {}), cache: 'no-store' });
}

// Populate query for the shared seo.seo component's openGraphImage media,
// restricted to `url` (the only field SEOHead consumes) to avoid returning
// full media metadata (formats/hash/mime/etc.) on every page fetch.
export const SEO_OG_IMAGE_POPULATE_QS = 'populate[seo][populate][openGraphImage][fields][0]=url';

// Strapi v4 wraps a singleType/component entity as { id, attributes: {...} };
// v5 returns it flat. Normalizes either shape to a flat object.
export function unwrapAttributes<T = any>(value: unknown): T {
  const v = value as any;
  return (v?.attributes ?? v ?? {}) as T;
}
